const ENDPOINT_CONFIG = {
  masterData : {
    getCities: 'order/cities',
    getCityDetail: 'order/city_detail',
    getListOfService: 'order/service_types',
    estimateFree: 'order/estimated_fee',
  },
  order: {
    create: 'order/create',
    cancel: 'order/cancel',
    getOrderList: 'order/list',
    getOrderDetail: 'order/detail'
  }
}

export default ENDPOINT_CONFIG